import React from "react";

// Shared shell + typography for legal pages
export default function LegalPage({ eyebrow, title, lastUpdated, lede, children }) {
  return (
    <div className="min-h-screen bg-[#FBF9F4]" style={{ fontFamily: "'Manrope', sans-serif" }}>
      <div className="max-w-3xl mx-auto px-6 lg:px-10 py-16">
        <div className="text-[10px] tracking-[0.3em] uppercase text-neutral-500">{eyebrow}</div>
        <h1 style={{ fontFamily: "'Cormorant Garamond', serif" }} className="text-5xl sm:text-6xl mt-3 font-light tracking-tight">{title}</h1>
        {lastUpdated && <p className="text-xs tracking-[0.2em] uppercase text-neutral-500 mt-3">Last updated · {lastUpdated}</p>}
        {lede && <p className="mt-8 text-lg text-neutral-700 leading-relaxed">{lede}</p>}
        <div className="mt-10 prose-soiree text-neutral-800 leading-relaxed text-base">
          {children}
        </div>
        <div className="mt-16 pt-8 border-t border-black/10 text-xs tracking-[0.25em] uppercase text-neutral-500 flex flex-wrap gap-6">
          <a href="/" className="hover:text-neutral-900">Soirée home</a>
          <a href="/legal/privacy" className="hover:text-neutral-900">Privacy</a>
          <a href="/legal/terms" className="hover:text-neutral-900">Terms</a>
          <a href="mailto:admin@soiree-invites.com" className="hover:text-neutral-900">admin@soiree-invites.com</a>
        </div>
      </div>
    </div>
  );
}

// Reusable typographic primitives for legal copy
export const H2 = ({ children }) => (
  <h2 style={{ fontFamily: "'Cormorant Garamond', serif" }} className="mt-12 text-3xl sm:text-4xl font-light tracking-tight">{children}</h2>
);
export const H3 = ({ children }) => (
  <h3 className="mt-8 text-base tracking-[0.18em] uppercase text-neutral-700 font-medium">{children}</h3>
);
export const P = ({ children }) => <p className="mt-4 text-neutral-700 leading-relaxed">{children}</p>;
export const UL = ({ children }) => <ul className="mt-4 space-y-2 list-disc list-outside ml-6 text-neutral-700">{children}</ul>;
export const LI = ({ children }) => <li className="leading-relaxed">{children}</li>;
export const Email = () => (
  <a href="mailto:admin@soiree-invites.com" className="underline underline-offset-4">admin@soiree-invites.com</a>
);
